export interface QueryParamDict {
    [key: string]: string;
}

export const createQueryString = (params: QueryParamDict): string => {
    const keyValues: string = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    return keyValues ? `?${keyValues}` : '';
  };